// Overdue (reschedule) panel for the Plan page rail.
import Panel from '@/components/ui/Panel';
import TaskList from '@/features/tasks/components/lists/TaskList';
import { useT } from '@/i18n/useT';
import {
  PANEL_FLAT_CLASS,
  PLAN_PANEL_A11Y,
  planRailListTabProps,
  railListProps,
} from '@/features/planning/components/shared/planRailPanelShared';

export default function PlanRailOverduePanel({
  overdueTasks,
  overdueRailSlice,
  selectedTaskIds,
  railSelectionHandlers,
  focusOwnerId,
  projectStateProps,
}) {
  const t = useT();
  if (!(overdueTasks?.length > 0)) return null;
  return (
    <Panel
      flat
      contentClassName={PANEL_FLAT_CLASS}
      testId="panel-overdue"
      title={t('plan.overdue', 'Reschedule')}
      count={overdueTasks.length}
      {...PLAN_PANEL_A11Y}
    >
      <TaskList
        tasks={overdueRailSlice}
        selectedTaskIds={selectedTaskIds}
        onSelectionChange={railSelectionHandlers.overdue}
        listId="overdue"
        focusOwnerId={focusOwnerId}
        {...railListProps}
        {...projectStateProps}
        {...planRailListTabProps(overdueRailSlice)}
      />
    </Panel>
  );
}
